import { initContract } from '@ts-rest/core';
import { z } from 'zod';

import { SortDirection } from '@e-origin/shared';

const c = initContract();

export const templateContract = c.router({
  retrieveTemplates: {
    method: 'POST',
    path: '/template',
    body: z.object({
      filters: z.record(z.unknown()).optional(),
      sorting: z.object({ field: z.string(), direction: z.enum([SortDirection.ASC, SortDirection.DESC]) }).optional(),
      pagination: z.object({ page: z.number(), size: z.number() }).optional(),
    }),
    responses: {
      200: z.object({
        data: z.object({
          list: z.array(z.any()),
          totalItems: z.number(),
        }),
      }),
    },
  },
  getEditFields: {
    method: 'GET',
    path: '/template/edit-fields',
    query: z.object({ type: z.string().optional() }),
    responses: {
      200: z.any(),
    },
  },
  exportTemplate: {
    method: 'GET',
    path: '/template/export-template/:templateId',
    pathParams: z.object({ templateId: z.string() }),
    responses: {
      200: c.otherResponse({ contentType: 'application/zip', body: z.any() }),
    },
  },
  getTemplate: {
    method: 'GET',
    path: '/template/:id',
    pathParams: z.object({ id: z.string() }),
    responses: {
      200: z.object({
        data: z.object({ template: z.any() }),
      }),
    },
  },
  createTemplate: {
    method: 'POST',
    path: '/template/add',
    body: z.record(z.unknown()),
    responses: {
      200: z.object({ data: z.any() }),
    },
  },
  updateTemplate: {
    method: 'PATCH',
    path: '/template',
    body: z.record(z.unknown()),
    responses: {
      200: z.object({ data: z.any() }),
    },
  },
  deleteTemplate: {
    method: 'DELETE',
    path: '/template/:id',
    pathParams: z.object({ id: z.string() }),
    body: c.noBody(),
    responses: {
      200: z.object({}),
    },
  },
  publishTemplate: {
    method: 'POST',
    path: '/template/publish',
    body: z.object({ _id: z.string() }),
    responses: {
      200: z.object({}),
    },
  },
  importTemplate: {
    method: 'POST',
    path: '/template/import-template',
    body: c.noBody(),
    contentType: 'multipart/form-data',
    responses: {
      201: z.object({ message: z.string() }),
    },
  },
});
